export default __webpack_public_path__ + "22d0e90d55059ea949c44161d2c4cdcf.png";